import { FetchCrudData } from '../../models';
import { UsersService } from '../../services';
import { ActionType } from './types';

export const getUsers = (filters: FetchCrudData) => ({ type: ActionType.GET_USERS, payload: UsersService.getUsers(filters) });
export const getMoreUsers = (filters: FetchCrudData) => ({
  type: ActionType.GET_MORE_USERS,
  payload: UsersService.getUsers(filters),
});
export const deleteUser = id => ({ type: ActionType.DELETE_USER, payload: UsersService.deleteUser(id) });
export const addUser = store => ({ type: ActionType.ADD_USER, payload: UsersService.addUser(store) });
export const editUser = (id, store) => ({ type: ActionType.EDIT_USER, payload: UsersService.editUser(id, store) });
